export default {"src":"/_next/static/media/faq-icon4.b8a57510.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};